import Icon, { IconName } from '@/components/atomic/icon'
import { BodySubtext, FontWeight } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const CashflowChartContainer: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  return (
    <div className={cn('h-full flex flex-col overflow-hidden', className)}>
      {children}
    </div>
  )
}

export const CashflowChartTitleContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <div className={cn('flex flex-col gap-y-2 px-4 py-4')}>{children}</div>
}

export const ChartTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <BodySubtext fontWeight={FontWeight.SemiBold}>{children}</BodySubtext>
)

export const CashflowTargetSuccessIcon: React.FC = () => (
  <Icon iconName={IconName.CheckCircleIcon} className="text-moment-green-800" />
)

export const CashflowTargetFailureIcon: React.FC = () => (
  <Icon
    iconName={IconName.XCircleIcon}
    className="text-moment-red-700 w-5 h-5"
  />
)

export const CashflowTargetStatusText: React.FC<{
  isSuccessful: boolean
  message: string
}> = ({ isSuccessful, message }) => {
  const className = isSuccessful
    ? 'text-moment-green-800'
    : 'text-moment-red-700'
  return (
    <BodySubtext className={className} fontWeight={FontWeight.Regular}>
      {message}
    </BodySubtext>
  )
}

export const CashflowChartPatterns: React.FC = () => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: Bulk suppression as part of biome migration
  <svg width="0" height="0">
    <defs>
      {/* biome-ignore lint/correctness/useUniqueElementIds: static id referenced by url(#diagonalHatch) in cashflow-income-chart */}
      <pattern
        id="diagonalHatch"
        patternUnits="userSpaceOnUse"
        width="4"
        height="4"
      >
        <path
          d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
          stroke="var(--color-moment-red-700)"
          strokeWidth="1"
        />
      </pattern>
    </defs>
  </svg>
)
